<style lang="less" scoped>
  @import "../../../vars.less";
  .button-container {
    padding: @space-normal @space-normal;
    background-color: #fff;
  }
</style>

<template>
  <div class="logistics">
    <van-search
      v-model="conditions.deliveryNumber"
      :placeholder="$t('请输入发货单号')" />
    <div class="button-container">
      <van-button type="info" size="small" round block @click="query" >{{ $t('查询物流') }}</van-button>
    </div>
  </div>
</template>

<script>
import { Search, Button, Toast } from 'vant'
export default {
  name: 'logistics',
  components: {
    'van-search': Search,
    'van-button': Button
  },
  data () {
    return {
      conditions: {
        deliveryNumber: ''
      }
    }
  },
  methods: {
    query () {
      if (!this.conditions.deliveryNumber.trim()) {
        Toast(this.$t('请输入发货单号'))
      } else {
        this.$router.push({
          name: 'logistics-query-result',
          query: this.conditions,
          params: {
            stackType: 'push'
          }
        })
      }
    }
  }
}
</script>
